import "./product.css";

const Product = ({img,link,tests}) => {
  return (<>
{/* //   <h1 className="p-n">
//  {tests}
//    </h1>   */}
 <div className="p"> 
 <a
                rel="noreferrer"
                style={{ color: "rgb(235, 246, 245)" }} 
                href="tel: 9650513361"
                target="_blank"
              >
        <img src={img}  className="p-img" alt=""/> 
  </a>
    </div>
      
     </>

  );
};

export default Product;
